export class InvoiceFilesForCreate {

  constructor(_FileName: string, _Data:string) {
    this.FileName = _FileName;
    this.Data = _Data;
  }

  public FileName: string | null;
  public Data: string;
}
